import { PayerItem } from "../models/payer-item";

type IdValue = string | number | null | undefined;

type ReadableOption = {
  ID?: number | string;
  Abbreviation?: string | null;
  Name?: string | null;
};

export class ReadabilityHelper {
  private getSelectedDisplayValuesByIds(
    ids?: string | IdValue[],
    options?: ReadableOption[],
    idSelector: (option: ReadableOption) => number | string | null | undefined = (option) => option.ID,
    displayValueSelector: (option: ReadableOption) => string = (option) => option.Abbreviation || option.Name || ""
  ): string {
    if (ids == null) {
      return "All";
    }

    let idList: IdValue[];

    if (typeof ids === "string") {
      if (ids.trim().length === 0) {
        return "All";
      }

      idList = ids.split(",").map((id) => id.trim());
    } else if (Array.isArray(ids)) {
      idList = ids;
    } else {
      throw Error("Invalid ids parameter");
    }

    const selectedIds = idList
      .map((id) => Number(id))
      .filter((id) => !Number.isNaN(id) && id > 0);

    if (selectedIds.length === 0) {
      return "All";
    }

    if (options?.length) {
      const selectedDisplayValues = options
        .filter((option) => selectedIds.includes(Number(idSelector(option) ?? NaN)))
        .map((option) => displayValueSelector(option) ?? "")
        .filter((value): value is string => value.length > 0);

      if (selectedDisplayValues.length > 0) {
        return selectedDisplayValues.join(", ");
      }
    }

    return selectedIds.join(", ");
  }

  public getSelectedPayerAbbreviationsByIds(
    ids?: string | IdValue[],
    payerOptions?: PayerItem[]
  ): string {
    return this.getSelectedDisplayValuesByIds(
      ids,
      payerOptions,
      (option) => option.ID,
      (option) => option.Abbreviation || option.Name || ""
    );
  }
}
